/**
 * Constants used throughout the filter system
 */
export const FILTER_CONSTANTS = {
  /**
   * Special key used in count maps to represent total record count
   */
  TOTAL_COUNT_KEY: 'count',
} as const;
